class ComplementaryProductsForm extends HTMLElement {
  connectedCallback() {
    this.mainFormId = this.dataset.mainForm;
    this.mainForm = this.mainFormId ? document.getElementById(this.mainFormId) : null;

    if (this.mainForm) {
      this.mainForm.addEventListener('submit', this.onMainFormSubmit.bind(this), { capture: true });
    }

    this.addEventListener('click', this.onRowClick.bind(this));
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  onVariantChange(event) {
    const select = event.target.closest('.horizontal-product__variant-select');

    if (!select) {
      return;
    }

    const checkbox = this.querySelector(`#${CSS.escape(select.dataset.checkboxId)}`);

    if (checkbox) {
      checkbox.value = select.value;
    }
  }

  onRowClick(event) {
    const image = event.target.closest('.horizontal-product__image--zoomable');

    if (image) {
      event.preventDefault();
      event.stopPropagation();
      ComplementaryProductsForm.openImageLightbox(image.dataset.zoomSrc, image.dataset.zoomAlt);
      return;
    }

    const titleLink = event.target.closest('.horizontal-product__title-link');

    if (titleLink) {
      event.stopPropagation();
      return;
    }

    const variantSelect = event.target.closest('.horizontal-product__variant-select');

    if (variantSelect) {
      event.stopPropagation();
    }
  }

  static openImageLightbox(src, alt) {
    if (!src) {
      return;
    }

    let overlay = document.querySelector('.complementary-lightbox');

    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'complementary-lightbox';
      overlay.innerHTML = '<img class="complementary-lightbox__image" alt="">';
      overlay.addEventListener('click', () => overlay.classList.remove('is-open'));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          overlay.classList.remove('is-open');
        }
      });
      document.body.appendChild(overlay);
    }

    const img = overlay.querySelector('.complementary-lightbox__image');
    img.src = src;
    img.alt = alt || '';
    overlay.classList.add('is-open');
  }

  getCheckedVariantIds() {
    return Array.from(this.querySelectorAll('input[name="complementary_product_ids[]"]:checked')).map(
      (input) => input.value
    );
  }

  onMainFormSubmit() {
    const variantIds = this.getCheckedVariantIds();

    if (variantIds.length === 0) {
      return;
    }

    this.waitForNotificationThenAddComplements(variantIds);
  }

  waitForNotificationThenAddComplements(variantIds) {
    const notificationDrawer = document.querySelector('cart-notification-drawer');

    if (!notificationDrawer) {
      this.addComplements(variantIds, null);
      return;
    }

    const tryHandle = () => {
      const banner = notificationDrawer.querySelector('.banner');

      if (!banner || banner.dataset.complementsHandled) {
        return false;
      }

      banner.dataset.complementsHandled = 'true';
      this.addComplements(variantIds, banner);
      return true;
    };

    if (tryHandle()) {
      return;
    }

    const observer = new MutationObserver(() => {
      if (tryHandle()) {
        observer.disconnect();
      }
    });

    observer.observe(notificationDrawer, { childList: true, subtree: true });

    setTimeout(() => {
      observer.disconnect();

      if (!notificationDrawer.querySelector('.banner[data-complements-handled]')) {
        this.addComplements(variantIds, notificationDrawer.querySelector('.banner'));
      }
    }, 4000);
  }

  addComplements(variantIds, banner) {
    const items = variantIds.map((id) => ({ id, quantity: 1 }));

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items })
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Add to cart request failed');
        }

        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        if (banner) {
          this.updateNotificationText(banner, variantIds.length);
        }
      })
      .catch(() => {
      });
  }

  updateNotificationText(banner, complementCount) {
    const label = complementCount === 1 ? 'article complémentaire' : 'articles complémentaires';

    const textNode = Array.from(banner.childNodes).find(
      (node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim().length > 0
    );

    if (textNode) {
      const baseMessage = textNode.textContent.trim().replace(/!+\s*$/, '').trim();
      textNode.textContent = ` ${baseMessage} + ${complementCount} ${label} !`;
    }
  }
}

if (!customElements.get('complementary-products-form')) {
  customElements.define('complementary-products-form', ComplementaryProductsForm);
}
